export default function ExponentialIntervalGenerator(
    maxInterval,
    _baselineInterval
) {
    const baselineInterval = _baselineInterval || 0;
    const maxAdditionalInterval = maxInterval - baselineInterval;
    let failures = 0;

    this.fail = function () {
        failures++;
    };

    this.reset = function () {
        failures = 0;
    };

    this.getInterval = function () {
        /*
            The max interval is determined by the following equation:

            2^k - 1

            We then multiple it by 1000 to convert it to milliseconds.
            */
        const expInterval = (Math.pow(2, failures) - 1) * 1000;
        const generatedMaxInterval = Math.min(
            expInterval,
            maxAdditionalInterval
        );

        // Get a random interval amount so that we don't flood the server with reconnect
        // requests from every single user at the same time.
        const interval =
            baselineInterval + Math.random() * generatedMaxInterval;
        return interval;
    };
}
